/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cloneDeep from 'lodash/cloneDeep';
import findIndex from 'lodash/findIndex';
import {
    GET_EQUIPMENT_INFO,
    GET_EQUIPMENT_INFO_ERROR,
    GET_RENTAL_EQUIPMENTS,
    GET_RENTAL_EQUIPMENTS_ERROR,
    GET_RENTAL_EQUIPMENT_INFO,
    SAVE_RENTALS_RESERVATIONS,
    UPDATE_RENTALS_RESERVATION,
    UPDATE_RENTALS_RESERVATION_ERROR,
} from '../constants';

const INITIALSTATE = {
    list: [],
    resRentalsInfo: [],
    equipments: [],
};

const rentalsReservations = (state = INITIALSTATE, action) => {
    const st = { ...state };
    switch (action.type) {
        case UPDATE_RENTALS_RESERVATION: {
            delete st.err;
            const index = findIndex(st.list, (item) => {
                return item.reservation.resource_id === action.payload.resource_id;
            });
            st.list[index] = { reservation: action.payload };
            return st;
        }
        case UPDATE_RENTALS_RESERVATION_ERROR:
            delete st.err;
            st.err = action.error;
            return st;
        case GET_RENTAL_EQUIPMENT_INFO:
            st.err = action.err;
            return st;
        case GET_RENTAL_EQUIPMENTS:
            st.equipments = action.payload;
            return st;
        case GET_RENTAL_EQUIPMENTS_ERROR:
            st.error = action.error;
            return st;
        case GET_EQUIPMENT_INFO: {
            const infoArr = cloneDeep(st.resRentalsInfo);
            infoArr.push(action.payload);
            st.resRentalsInfo = cloneDeep(infoArr);
            return st;
        }
        case GET_EQUIPMENT_INFO_ERROR:
            st.error = action.error;
            return st;
        case SAVE_RENTALS_RESERVATIONS:
            st.list = action.payload;
            return st;
        default:
            return st;
    }
};

export default rentalsReservations;
